<div motifDropdown [open]="false">
  <motif-chip
    [disabled]="isDisabled"
    motifDropdownToggle
    class="roleChip"
    [ngStyle]="{ '--chip-hover--bg-color': getChipHoverColor() }"
    [removeable]="false"
    [variant]="getVariant()"
    [type]="'chip'"
    [dotSide]="'none'"
    >{{ selectedvalue?.RoleName | translate }}
    <motif-icon size="20" [iconFunction]="arrowDownIcon"></motif-icon>
  </motif-chip>
  <div
    class="listDiv"
    motifDropdownMenu
    id="motifExampleDropdownMenu"
    aria-labelledby="motifExampleDropdown"
  >
    <ng-container *ngFor="let item of list; trackBy: trackByRoleName">
      <button
        motifDropdownItem
        [ngClass]="{ 'selected-status': selectedvalue === item }"
        motifButton
        (click)="selectEvent(item)"
      >
        {{ item.RoleName | translate }}
      </button>
    </ng-container>
  </div>
</div>
